export default __webpack_public_path__ + "static/media/tape_thumbnail.9f9b917e.svg";